export const TRANSLATIONS_EN = {
  username: "Username",
  password: "Password",
  login: "LOGIN",
  registerMsg: "Not registered yet?",
  registerMsg2: "Click here",
  modalMsg: "Incorrect password and/or username",
};
